module.exports = __webpack_public_path__ + "static/media/financial@2x.62a70f5e.png";